<template>
    <div>

        <div class="container-fluid border-bottom-light d-flex align-items-center">
            <div class="col-sm-10 fs-largest darker py-3">
                <router-link to="/calendar" tag="span" class="pointer">
                    <i class="ico ico-arrow-left fs-larger"></i>
                    {{reservation.product.name}}: {{departure}}
                </router-link>
            </div>

        </div>

    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        data: function() {
            return {
                selectedAgent: null,
            }
        },
        props: {
            reservation: {
                type: Object,
            },
            selectedAgentComissions: {
                type: Object,
                default: null
            }
        },
        computed: {
            ...mapGetters([
                'getAgents',
                'account'
            ]),
            departure: function() {
                return  moment(this.reservation.event.start).format('DD/MM/YYYY - hh:mmA')
            },
        },
        methods:{
            ...mapActions([
            ]),
        }
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Navigator.vue?042cff6b